export const Inter = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 'normal',
  src: "url(https://fonts.googleapis.com/css2?family=Exo:wght@100&display=swap')",
}
